(function () {
  'use strict';

  angular.module('eclipseApp.autoRegSetPassword')
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('setPasswordError', {
          url: '/set-password/error',
          params: {
            api: null,
            errorCode: null,
            errorMessage: null
          },
          title: 'set-password',
          parent: 'app',
          views: {
            content: {
              templateUrl: 'modules/auto-reg/error/error-page.view.html',
              controller: 'setAutoRegPasswordErrorCtrl'
            }
          }
        })
        .state('setPasswordSuccess', {
          url: '/set-password/success',
          title: 'set-password',
          parent: 'app',
          resolve: {
            showPage: ['setPasswordService', '$q', '$state', '$translate', showPage]
          },
          views: {
            content: {
              templateUrl: 'modules/auto-reg/success/success-page.view.html',
              controller: 'setAutoRegPasswordSuccessCtrl',
              controllerAs: 'ctrl'
            }
          }
        })
        .state('setPasswordExpired', {
          url: '/set-password/expired',
          title: 'set-password',
          parent: 'app',
          resolve: {
            showPage: ['setPasswordService', '$q', '$state', '$translate', showPage]
          },
          views: {
            content: {
              templateUrl: 'modules/auto-reg/expired/expired-page.view.html',
              controller: 'setAutoRegPasswordExpiredCtrl',
              controllerAs: 'ctrl'
            }
          }
        })
        .state('setPassword', {
          url: '/set-password/:token',
          title: 'set-password',
          parent: 'app',
          views: {
            content: {
              templateUrl: 'modules/auto-reg/set-password.view.html',
              controller: 'setAutoRegPasswordCtrl',
              controllerAs: 'ctrl'
            }
          }
        });
    }]);

  function showPage(setPasswordService, $q, $state, $translate) {
    var deferred = $q.defer();
    if (setPasswordService.showModule()) {
      deferred.resolve();
    } else {
      $translate('global.label.setAutoRegistrationPassword.error.systemError')
        .then(function (translatedValue) {
          $state.go('setPasswordError', {
            errorCode: 'SMSReg05',
            errorMessage: translatedValue
          });
      });
    }
    return deferred.promise;
  }

})();
